import * as React from 'react';

import { Gallery } from './gallery';
import styles from './index.css';
import { NavigationLinkTypes } from '../../constants/navigation';
import { INeighbourhoodSchema } from '../../types';
import { isArrayWithItems } from '../../utils/helpers';
import { BlockErrorBoundary } from '../BlockErrorBoundary';
import { ThumbsGallery } from '../common/thumbs_gallery';

export interface INeighbourhoodProps {
  neighbourhoodList: INeighbourhoodSchema[];
}

export interface INeighbourhoodState {
  activeSlide: number;
  galleryOpened: boolean;
}

export interface INeighbourhoodDispatchProps {
  setNavigationLink(): void;
}

export type INeighbourhoodGalleryPropsValue = INeighbourhoodProps & INeighbourhoodDispatchProps;

export class NeighbourhoodGallery extends React.Component<INeighbourhoodGalleryPropsValue, INeighbourhoodState> {
  public state = {
    activeSlide: 0,
    galleryOpened: false,
  };

  public componentDidMount() {
    const { neighbourhoodList } = this.props;
    if (isArrayWithItems(neighbourhoodList)) {
      this.props.setNavigationLink();
    }
  }

  public render() {
    const { neighbourhoodList } = this.props;
    if (!isArrayWithItems(neighbourhoodList)) {
      return <div />;
    }

    return (
      <div id={NavigationLinkTypes.Neighbourhood} className={styles['container']}>
        <h2 className={styles['title']}>Окрестности</h2>
        <ThumbsGallery thumbs={neighbourhoodList} onSlideClick={this.openSlide} />
        {this.state.galleryOpened && (
          <BlockErrorBoundary>
            <Gallery
              data={this.props.neighbourhoodList}
              currentSlide={this.state.activeSlide}
              onClose={() => this.setState({ galleryOpened: false, activeSlide: 0 })}
              changeSlide={activeSlide => this.setState({ activeSlide })}
            />
          </BlockErrorBoundary>
        )}
      </div>
    );
  }

  private openSlide = (index: number) => this.setState({ activeSlide: index, galleryOpened: true });
}
